export default __webpack_public_path__ + "static/media/KAAN04.428061a4.png";